export const GROUPED_HEADER_FONT_SIZE_PX = 12;
export const DEFAULT_HEADER_FONT_SIZE_PX = 14;
